import gql from 'graphql-tag'

export default gql`mutation setProjectClientInvoice($data: ProjectClientInvoiceInput) {
    setProjectClientInvoice(data: $data) @client
}`